export const TEACHER_PORTAL_ROLES: Record<string, string> = {
  teacher: 'ROLE_TEACHER',
  monitor: 'ROLE_MONITOR',
  teacheradmin: 'ROLE_TEACHER_ADMIN',
  acadadmin: 'ROLE_ACAD_ADMIN',
  copyeditor: 'ROLE_copyeditor',
  sysadmin: 'ROLE_SYS_ADMIN',
};
